import React from 'react';

const CareersEarly: React.FC = () => {
  return (
    <section className="careers-section careers-early">
      <div className="container">
        <h2 className="section-title">Launch your career</h2>
        <p className="section-subtitle">
          Whether you're a student, fresh graduate, or early professional, we have programs 
          designed to accelerate your growth in cloud, AI, and education technology.
        </p>
        
        <div className="careers-grid">
          <div className="career-card">
            <h3>Students & Internships</h3>
            <p>
              Get hands-on experience with real projects, mentorship from industry experts, 
              and exposure to cutting-edge technologies. Our internship programs offer pathways 
              in cloud engineering, AI research, data science, and educational technology.
            </p>
            <a href="#" className="btn-primary">Explore internships</a>
          </div>
          
          <div className="career-card">
            <h3>Graduates & Early Professionals</h3>
            <p>
              Join our graduate programs and bootcamps designed for recent graduates and career changers. 
              Learn from experienced professionals while working on impactful projects that shape 
              the future of technology education.
            </p>
            <a href="#" className="btn-primary">Explore graduate roles</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersEarly;